<template>
<!-- 会员管理－单个购买订单记录 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'orderRecord')">
            <div class="wrap-container-in">
                <a-table bordered :dataSource="dataSource" :columns="columns" :pagination="false" :rowKey="record => record.id">
                    <span slot="name" slot-scope="a, row"><router-link class="text-primary" :to="{name:'detailTicket', query: {id: row.ticketId}}">{{row.name}}</router-link></span>
                    <span slot="type" slot-scope="type">{{['','期限卡','次卡','套餐票'][type]}}</span>
                    <span slot="payState" slot-scope="a, row">{{$utils.payState[row.payState]}}</span>
                    <span slot="expirationDate" slot-scope="a, row">剩余使用次数:{{row.total === -1 ? '不限次' : row.total - row.used}}；有效期:{{row.expirationDate.substr(0,10)}}</span>
                    <span slot="orderTime" slot-scope="a, row">下单时间:{{row.orderTime}} 订单金额:{{row.price}} 元</span>
                    <span slot="payTime" slot-scope="a, row">支付时间:{{row.payTime}} 订单金额:{{row.price}} 元</span>
                    
                    <span slot="action" slot-scope="a, row">
                        <span class="text-disabled" v-if="row.payState == 5">使用详情</span>
                        <router-link class="text-primary" :to="{name:'useDetailMember', query: {userTicketId: row.id}}" v-else>使用详情</router-link>
                        <a-divider type="vertical"/>

                        <a class="text-primary" @click="openVisibleUpgrade(row.id)" v-if="row.type === 1">升级</a>
                        <span class="text-disabled" v-else>升级</span>
                        <a-divider type="vertical"/>

                        <a class="text-primary" @click="openVisibleRefund(row.id)">退款</a>
                        <a-divider type="vertical"/>

                        <a class="text-primary" @click="openVisibleRedate(row.id)" v-if="row.type === 1">有效期重置</a>
                        <span class="text-disabled" v-else>有效期重置</span>
                        <a-divider type="vertical"/>

                        <a class="text-primary" @click="openVisiblePhone(row.id)">持有者更改</a>
                        <a-divider type="vertical"/>

                        <span class="text-disabled" v-if="row.payState == 4 || row.payState == 5">{{row.forbiddenState == 0 ? '禁用' :'取消禁用'}}</span>
                        <a-popconfirm
                        :title="`确定将用户“${row.account}”购买的商品“${row.name}”进行${row.forbiddenState == 0 ? '' :'取消'}禁用操作吗?`"
                        @confirm="orderState(row.id, row.forbiddenState)"
                        v-else
                        >
                            <a class="text-primary">{{row.forbiddenState == 0 ? '禁用' :'取消禁用'}}</a>
                        </a-popconfirm>
                    </span>
                </a-table>
                <div class="mt32 text-center">
                    <a-button >返回</a-button>
                </div>
                <!-- 退款 -->
                <member-order-refund ref="refund" @changeVisibleRefund="changeVisibleRefund" :ticketData="ticketData" :visibleRefund="visibleRefund"></member-order-refund>
                <!-- 升级 -->
                <member-order-upgrade ref="upgrade" @changeVisibleUpgrade="changeVisibleUpgrade" :ticketData="ticketData" :visibleUpgrade="visibleUpgrade"></member-order-upgrade>
                <!-- 有效期重置 -->
                <member-order-redate ref="redate" @changeVisibleRedate="changeVisibleRedate" :ticketData="ticketData" :visibleRedate="visibleRedate"></member-order-redate>
                <!-- 持有者更改 -->
                <member-order-phone ref="phone" @changeVisiblePhone="changeVisiblePhone" :ticketData="ticketData" :visiblePhone="visiblePhone"></member-order-phone>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import memberOrderRefund from "@/components/modules/order/member-order-refund.component";
    import memberOrderUpgrade from "@/components/modules/order/member-order-upgrade.component";
    import memberOrderRedate from "@/components/modules/order/member-order-redate.component";
    import memberOrderPhone from "@/components/modules/order/member-order-phone.component";
    export default {
        name: "orderRecord",
        components: {
            memberOrderRefund,
            memberOrderUpgrade,
            memberOrderRedate,
            memberOrderPhone,
        },
        props: {},
        data() {
            const columns = [
            {
                title: "订单号",
                dataIndex: "orderId"
            },
            {
                title: "商品名称",
                dataIndex: "name",
                scopedSlots: { customRender: "name" }
            },
            {
                title: "商品类型",
                dataIndex: "type",
                scopedSlots: { customRender: "type" }
            },
            {
                title: "订单状态",
                dataIndex: "payState",
                scopedSlots: { customRender: "payState" }
            },
            {
                title: "订单信息",
                dataIndex: "expirationDate",
                scopedSlots: { customRender: "expirationDate" }
            },
            {
                title: "下单信息",
                dataIndex: "orderTime",
                scopedSlots: { customRender: "orderTime" }
            },
            {
                title: "支付信息",
                dataIndex: "payTime",
                scopedSlots: { customRender: "payTime" }
            },
            {
                title: "操作",
                key: "action",
                scopedSlots: { customRender: "action" }
            }]
            return {
                columns,
                dataSource: [],
                // 会员账号-从会员列表跳转带入
                account: '',
                visibleRefund: false,
                visibleUpgrade: false,
                visibleRedate: false,
                visiblePhone: false,
                ticketData: {}
            };
        },
        computed: {
            ...mapGetters(["shopId", "shopName"]),
        },
        methods: {
            // 获取会员积分详情
            getList() {
                this.$api.order.orderSearch({
                    body: {
                        goodsType: "TICKET",
                        account: this.account
                    }
                }).then(res => {
                    this.dataSource = res.data
                })
            },
            
            // 获取基础票券详情
            getDetail(id) {
                this.$api.order
                .detailUserTicket({
                    params: {userTicketNo: this.$route.query.id}
                })
                .then(res => {
                    this.ticketData = res
                });
            },

            // 打开/关闭退款详情弹框
            openVisibleRefund(id) {
                this.visibleRefund = true
                this.getDetail(id)
            },
            changeVisibleRefund(val) {
                this.visibleRefund = val
                this.getList()
            },

            // 打开/关闭升级详情弹框
            openVisibleUpgrade(id) {
                this.visibleUpgrade = true
                this.getDetail(id)
            },
            changeVisibleUpgrade(val) {
                this.visibleUpgrade = val
                this.getList()
            },

            // 打开/关闭有效期重置详情弹框
            openVisibleRedate(id) {
                this.visibleRedate = true
                this.getDetail(id)
            },
            changeVisibleRedate(val) {
                this.visibleRedate = val
                this.getList()
            },

            // 打开/关闭持有者更改详情弹框
            openVisiblePhone(id) {
                this.visiblePhone = true
                this.getDetail(id)
            },
            changeVisiblePhone(val) {
                this.visiblePhone = val
                this.getList()
            },

            // 更改禁用解禁状态
            orderState(id, state) {
                const newState = state == '1' ? '0' : '1'
                this.$api.order.forbidden({
                    params: {id: id, flag: newState}
                })
                .then(res => {
                    this.$message.success('操作成功',2)
                    this.getList()
                })
            },
        },
        created() {},
        mounted() {
            this.account = this.$route.query.account
            this.getList()
        },
        beforeCreate() {
            this.formModelRefund = this.$form.createForm(this);
            this.formModelUpgrade = this.$form.createForm(this);
            this.formModelRedate = this.$form.createForm(this);
        },
    };
</script>
<style lang="scss">
    .vip-card {
        margin-bottom: 16px;
        padding: 16px;
        background:rgba(250,250,250,1);
        border-radius:4px;
        border:1px solid rgba(233,233,233,1);
        overflow: auto;

        .ant-row {
            height: 22px;
            line-height: 30px;
        }
        .text-fail {
            font-size: 16px;
            font-weight: 600;
        }
    }
    .refund-form {
        .ant-row {
            margin-bottom: 8px;
        }
    }
</style>